import { Directive, forwardRef, OnChanges, SimpleChanges, Type, input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors } from '@angular/forms';

import { SecuritiesTransfersSymbol } from '../../../domain/transfers.domain';

import { SecuritiesTransferContext } from './securities-transfers-context';

@Directive({
  selector: '[tdWbSecuritiesTransfersSymbolValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef((): Type<SecuritiesTransfersSymbolValidatorDirective> => SecuritiesTransfersSymbolValidatorDirective),
    multi: true
  }]

})
export class SecuritiesTransfersSymbolValidatorDirective implements Validator, OnChanges {
  readonly tdWbSecuritiesTransfersSymbolValidator = input<[
    SecuritiesTransfersSymbol,
    SecuritiesTransferContext
]>(undefined);

  // Tuple with <selectedFrom, list of toAccounts found>
  private onChange: () => void;
  private securitiesSelected: boolean;
  private cashInputEnabled: boolean;
  private cashAmountEntered: boolean;

  validate(): ValidationErrors | null {
    const enteredSymbol = this.tdWbSecuritiesTransfersSymbolValidator()[0];
    const context = this.tdWbSecuritiesTransfersSymbolValidator()[1];

    if (context === undefined) {
      return null;
    }

    this.securitiesSelected = context.isSecuritiesSelected();
    this.cashInputEnabled = context.showCashInputField();
    this.cashAmountEntered = context.isCashAmountEntered();

    if (!this.isEligibility(enteredSymbol)) {
      return { ineligible : true };
    }
    if (this.hasSymbol(enteredSymbol, context)) {
      return { exists: true };
    }
    if (this.isEmpty()) {
      return { requiredToContinue: true };
    }
    return null;
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes !== undefined && this.onChange !== undefined) {
      this.onChange();
    }
  }

  private isEmpty(): boolean {
    return (!this.securitiesSelected && !this.cashInputEnabled ||
      (!this.securitiesSelected && ( this.cashInputEnabled && !this.cashAmountEntered)));
  }

  private isEligibility(enteredSymbol: SecuritiesTransfersSymbol): boolean {
    if (enteredSymbol === null || enteredSymbol === undefined) {
      return true;
    }
    return enteredSymbol.eligibility !== undefined && enteredSymbol.eligibility;
  }

  private hasSymbol(enteredSymbol: SecuritiesTransfersSymbol, context: SecuritiesTransferContext): boolean {
    if (enteredSymbol === null || enteredSymbol === undefined) {
      return false;
    }
    return context.hasSymbol(enteredSymbol);
  }
}

